import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
export var key = 'tracking';
var initialState = {
  enabled: true
};

//
// Actions
//
export var actions = {
  enableTracking: createAction('Tracking: enableTracking'),
  disabledTracking: createAction('Tracking: disabledTrackking'),
  trackPage: createAction('Tracking: trackPage', function (path) {
    return path;
  }),
  trackEvent: createAction('Tracking: trackEvent', function (event) {
    return event;
  })
};

//
// Reducer
//
export var reducer = createReducer(_defineProperty(_defineProperty({}, actions.enableTracking, function (state) {
  return Immutable.merge(state, {
    enabled: true
  });
}), actions.disabledTracking, function (state) {
  return Immutable.merge(state, {
    enabled: false
  });
}), initialState);

//
// Selectors
//
var root = function root(state) {
  return state[key];
};
var enabled = function enabled(state) {
  return root(state).enabled;
};
export var selectors = {
  enabled: enabled
};